export default __webpack_public_path__ + "static/Card17-c977e72e7dfc2c87c1ce7e4ff35a7b96.png";